module.exports = __webpack_public_path__ + "img/bg_usdt.6e4b1bcf.jpg";